import { useState, useRef } from 'react';
import dynamic from 'next/dynamic';
import axios from 'axios';
import { useLocationState } from '../../context/location';
import Input from '../Input';
import Button from '../Button';
import css from '../../styles/modules/objects/ObjectsMapCatalogCommercialItem.module.scss';

const Modal = dynamic(() => import('../Modal'));

const ObjectsMapCatalogCommercialItem = () => {
  /** STATES */
  const locationState = useLocationState();
  const [isModalFeedbackVisible, setIsModalFeedbackVisible] = useState(false);
  const [isModalSuccessVisible, setIsModalSuccessVisible] = useState(false);
  const [clientName, setClientName] = useState('');
  const [clientPhone, setClientPhone] = useState('');
  const clientNameId = useRef();
  const clientPhoneId = useRef();

  /** HANDLERS */
  const handleFormSubmit = () => {
    clientNameId.current.setError(clientName.length <= 3);
    clientPhoneId.current.setError(clientPhone.length !== 11);

    if (clientName.length > 3 && clientPhone.length === 11) {
      setIsModalCallVisible(false);
      setIsModalSuccessVisible(true);

      axios.post(process.env.NEXT_PUBLIC_API + '/client', {
        clientName,
        clientPhone,
        pathName: window.location.pathname,
        whatComponent: 'ObjectsMapCatalogCommercialItem',
        location: locationState.region,
        platform: 'web'
      });
    }
  };

  /** TEMPLATE */
  return (
    <div className={css.commercial}>
      <Modal
        title="Заявка на подбор"
        visibility={isModalSuccessVisible}
        onClose={() => setIsModalSuccessVisible(false)}
      >
        <div style={{ marginBottom: 18 }}>
          Спасибо за вашу заявку. Мы скоро с Вами свяжемся!
        </div>
        <img src="/images/man-with-message.svg" alt="" style={{ margin: 32 }} />
      </Modal>
      <Modal
        title="Заявка на подбор"
        button="Отправить"
        action={handleFormSubmit}
        visibility={isModalFeedbackVisible}
        onClose={() => setIsModalFeedbackVisible(false)}
      >
        <div style={{ marginBottom: 18 }}>
          Оставьте свои контактные данные и мы с Вами свяжемся в самые кратчайшие сроки,
          подберем лучшие объекты!
        </div>
        <Input
          title="Имя"
          inputs={[
            {
              placeholder: 'Иван Петрович',
              value: clientName,
              type: 'text'
            }
          ]}
          isWrappedStyle
          ref={clientNameId}
          onChange={(v) =>  setClientName(v[0])}
        />
        <Input
          title="Телефон"
          inputs={[
            {
              placeholder: locationState.phone,
              value: clientPhone,
              mask: 'phone',
              type: 'tel'
            }
          ]}
          isWrappedStyle
          ref={clientPhoneId}
          onChange={(v) => setClientPhone(v[0])}
        />
        <div style={{ textAlign: 'center', opacity: 0.8, fontSize: 14, margin: '18px 0' }}>
          Вы соглашаетесь с{' '}
          <a href="/faq/policy" target="_blank">
            политикой конфиденциальности
          </a>{' '}
          при отправке данной формы к нам в работу
        </div>
      </Modal>
      <div className={css.commercialContent}>
        <div className={css.comemrcialTitle}>Не нашли подходящего варианта?</div>
        <div className={css.comemrcialDescription}>Оставьте заявку на подбор объекта из закрытой базы нашим специалистам!</div>
      </div>
      <Button
        color="white"
        style={{ fontSize: 18, fontWeight: 600, padding: '12px 18px', flexShrink: 0 }}
        onClick={() => setIsModalFeedbackVisible(true)}
      >
        Подобрать варианты
      </Button>
    </div>
  );
};

export default ObjectsMapCatalogCommercialItem;
